import React from 'react';
import styled, { css } from 'styled-components';

const ImageView = ({ viewImage = '', onClose }) => {
  return (
    <Background view={viewImage !== ''} onClick={onClose}>
      <CloseButton onClick={onClose} />
      <img
        src={viewImage}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      />
    </Background>
  );
};

const Background = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);
  overflow-y: auto;
  ${(props) =>
    !props.view &&
    css`
      visibility: hidden;
    `};
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  :before {
    content: '';
    display: flex;
    width: 18px;
    height: 18px;
    background: url('/images/sp_layout.png') no-repeat -50px 0;
    background-size: 350px 350px;
  }
`;

export default ImageView;
